import React from "react";
import { FaBars, FaAngleDoubleLeft, FaAngleDoubleRight } from "react-icons/fa";
import { useAuth } from "../context/AuthContext";
import { useNavigate } from "react-router-dom";

export default function NavbarTop({
    onMenu, // mobile open
    sidebarCollapsed, // desktop state
    onToggleSidebarCollapse, // desktop toggle
}) {
    const { logout } = useAuth();
    const navigate = useNavigate();

    const onLogout = () => {
        logout();
        navigate("/login");
    };

    return (
        <nav className="navbar navbar-expand bg-white border-bottom sticky-top">
            <div className="container-fluid">
                <div className="d-flex align-items-center gap-2">
                    {/* Mobile menu button (opens drawer) */}
                    <button
                        className="btn btn-outline-secondary d-lg-none"
                        onClick={onMenu}
                        type="button"
                        aria-label="Open menu"
                    >
                        <FaBars />
                    </button>

                    {/* Desktop collapse/expand button */}
                    <button
                        className="btn btn-outline-secondary d-none d-lg-inline-flex"
                        onClick={onToggleSidebarCollapse}
                        type="button"
                        aria-label={sidebarCollapsed ? "Expand sidebar" : "Collapse sidebar"}
                        title={sidebarCollapsed ? "Expand sidebar" : "Collapse sidebar"}
                    >
                        {sidebarCollapsed ? <FaAngleDoubleRight /> : <FaAngleDoubleLeft />}
                    </button>

                    <span className="navbar-brand ms-1 fw-semibold">Admin Panel</span>
                </div>

                <div className="ms-auto d-flex align-items-center gap-2">
                    <div className="d-none d-md-block text-end">
                        <div className="fw-semibold small">Admin</div>
                        <div className="text-muted small">Owner</div>
                    </div>

                    <button className="btn btn-outline-danger btn-sm" onClick={onLogout}>
                        Logout
                    </button>
                </div>
            </div>
        </nav>
    );
}
